import React from "react";
import { useSelector } from "react-redux";
import { getIndexCampaigns } from "../../../store/indexCampaigns/selectors";
import Frame from "../Frame/Frame";
import Container from "../Container";
import { FlightCampaignTCBanner } from "./";

export function GeniusFlightsHomeBanner() {
  const { genius: geniusCampaign } = useSelector(getIndexCampaigns);

  if (!geniusCampaign) {
    return null;
  }

  return (
    <Container>
      <Frame mt={6} mb={8}>
        <FlightCampaignTCBanner campaignBanner={geniusCampaign} />
      </Frame>
    </Container>
  );
}
